(function () {
  'use strict';

  var body = document.body;
  if (!body || !body.matches('[data-kjs-search-phase="6"]')) return;

  function setCartDrawerClasses(element, isCartDrawer) {
    if (!element) return;
    element.classList.toggle('kjs-cart-drawer', isCartDrawer);
    element.classList.toggle('mfp-drawer', isCartDrawer);
    element.classList.toggle('mfp-move-from-right', isCartDrawer);
    if (isCartDrawer) element.classList.remove('mfp-move-from-top');
  }

  function syncCartDrawer() {
    var wraps = document.querySelectorAll('.mfp-wrap');
    var cartDrawerOpen = false;
    var index;

    for (index = 0; index < wraps.length; index += 1) {
      var wrap = wraps[index];
      var cart = wrap.querySelector('.modal-popup > .cart_menu');
      var isCartDrawer = Boolean(cart);
      var modal;
      var title;
      var closeButton;

      setCartDrawerClasses(wrap, isCartDrawer);
      if (!isCartDrawer) continue;

      cartDrawerOpen = true;
      modal = cart.parentElement;
      title = cart.querySelector('.menu_title h4');
      closeButton = modal.querySelector('.mfp-close');

      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      if (title) {
        title.id = 'kjs-cart-drawer-title';
        modal.setAttribute('aria-labelledby', title.id);
        modal.removeAttribute('aria-label');
      } else {
        modal.setAttribute('aria-label', 'Shopping cart');
        modal.removeAttribute('aria-labelledby');
      }
      if (closeButton) closeButton.setAttribute('aria-label', 'Close shopping cart');
    }

    var backgrounds = document.querySelectorAll('.mfp-bg');
    for (index = 0; index < backgrounds.length; index += 1) {
      setCartDrawerClasses(backgrounds[index], cartDrawerOpen);
    }
  }

  syncCartDrawer();
  if (window.MutationObserver) {
    new MutationObserver(syncCartDrawer).observe(body, {
      childList: true,
      subtree: true
    });
  }
}());

(function () {
  'use strict';

  var body = document.body;
  if (!body || !body.matches('[data-kjs-search-phase="6"].template-search')) return;

  body.classList.add('kjs-v6-ready');

  function setInert(element, shouldBeInert) {
    if (!element) return;
    element.inert = shouldBeInert;
    if (shouldBeInert) {
      element.setAttribute('inert', '');
      element.setAttribute('aria-hidden', 'true');
    } else {
      element.removeAttribute('inert');
      element.removeAttribute('aria-hidden');
    }
  }

  function getFocusable(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return element.offsetWidth > 0 || element.offsetHeight > 0;
    });
  }

  function trapTab(event, container) {
    if (event.key !== 'Tab') return;
    var focusable = getFocusable(container);
    if (!focusable.length) {
      event.preventDefault();
      container.focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-kjs-search-sort]'), function (select) {
    if (select.getAttribute('data-kjs-v6-bound') === 'true') return;
    select.setAttribute('data-kjs-v6-bound', 'true');
    select.addEventListener('change', function () {
      var form = select.form;
      if (!form) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  });

  var toggle = document.querySelector('[data-kjs-search-filter-toggle]');
  var drawer = document.getElementById('KjsSearchFilters');
  var closeButton = drawer && drawer.querySelector('[data-kjs-search-filter-close]');
  var overlay = document.querySelector('[data-kjs-search-filter-overlay]');
  var mobileQuery = window.matchMedia('(max-width: 1024px)');
  var backgroundState = [];

  if (!toggle || !drawer || toggle.getAttribute('data-kjs-v6-bound') === 'true') return;
  toggle.setAttribute('data-kjs-v6-bound', 'true');

  function isolateBackground() {
    backgroundState = [];
    var current = drawer;
    while (current && current !== body) {
      var parent = current.parentElement;
      if (!parent) break;
      Array.prototype.forEach.call(parent.children, function (sibling) {
        if (sibling === current || sibling === overlay || sibling.contains(overlay)) return;
        backgroundState.push({
          element: sibling,
          inert: sibling.inert,
          inertAttribute: sibling.getAttribute('inert'),
          ariaHidden: sibling.getAttribute('aria-hidden')
        });
        sibling.inert = true;
        sibling.setAttribute('inert', '');
        sibling.setAttribute('aria-hidden', 'true');
      });
      current = parent;
    }
  }

  function restoreBackground() {
    backgroundState.forEach(function (entry) {
      entry.element.inert = entry.inert;
      if (entry.inertAttribute === null) entry.element.removeAttribute('inert');
      else entry.element.setAttribute('inert', entry.inertAttribute);
      if (entry.ariaHidden === null) entry.element.removeAttribute('aria-hidden');
      else entry.element.setAttribute('aria-hidden', entry.ariaHidden);
    });
    backgroundState = [];
  }

  function closeDrawer(restoreFocus) {
    body.classList.remove('kjs-filter-open');
    toggle.setAttribute('aria-expanded', 'false');
    drawer.removeAttribute('role');
    drawer.removeAttribute('aria-modal');
    restoreBackground();
    if (mobileQuery.matches) setInert(drawer, true);
    if (restoreFocus) {
      toggle.focus();
      window.setTimeout(function () {
        if (!body.classList.contains('kjs-filter-open')) toggle.focus();
      }, 0);
      window.setTimeout(function () {
        if (!body.classList.contains('kjs-filter-open')) toggle.focus();
      }, 150);
    }
  }

  function openDrawer() {
    if (!mobileQuery.matches) return;
    body.classList.add('kjs-filter-open');
    toggle.setAttribute('aria-expanded', 'true');
    setInert(drawer, false);
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    (closeButton || getFocusable(drawer)[0] || drawer).focus({ preventScroll: true });
    isolateBackground();
  }

  function syncBreakpoint() {
    if (mobileQuery.matches) {
      closeDrawer(false);
    } else {
      body.classList.remove('kjs-filter-open');
      toggle.setAttribute('aria-expanded', 'false');
      drawer.removeAttribute('role');
      drawer.removeAttribute('aria-modal');
      restoreBackground();
      setInert(drawer, false);
    }
  }

  toggle.addEventListener('click', function (event) {
    event.preventDefault();
    openDrawer();
  });

  if (closeButton) {
    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      closeDrawer(true);
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function (event) {
      event.preventDefault();
      closeDrawer(true);
    });
  }

  drawer.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer(true);
    } else if (body.classList.contains('kjs-filter-open')) {
      trapTab(event, drawer);
    }
  });

  window.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && body.classList.contains('kjs-filter-open')) {
      closeDrawer(true);
    }
  });

  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', syncBreakpoint);
  else mobileQuery.addListener(syncBreakpoint);

  syncBreakpoint();
}());

(function () {
  'use strict';

  var body = document.body;
  var panel;
  var purchaseControls;
  var productTitle;
  var titleSource;
  var summary;
  var price;
  var galleryColumn;
  var mobileQuery;
  var categoryNavigation;
  var productDetails;

  if (!body || !body.matches('[data-kjs-search-phase="6"].template-product')) return;

  panel = document.querySelector('.desc_blk');
  purchaseControls = panel && panel.querySelector('.desc_blk_bot');
  productTitle = document.querySelector('#content .title h1');

  if (!panel || !purchaseControls || !productTitle) return;

  titleSource = productTitle.parentElement;
  summary = document.createElement('div');
  summary.className = 'kjs-option1-summary';

  (function addCategories() {
    var originalLinks = panel.querySelectorAll('.product_tags a.tag');
    var navigation;
    var index;
    var link;

    if (!originalLinks.length) return;

    navigation = document.createElement('nav');
    navigation.className = 'kjs-option1-categories';
    navigation.setAttribute('aria-label', 'Product categories');
    categoryNavigation = navigation;

    for (index = 0; index < originalLinks.length; index += 1) {
      link = document.createElement('a');
      link.href = originalLinks[index].href;
      link.textContent = originalLinks[index].textContent.replace(/^\s+|\s+$/g, '');
      navigation.appendChild(link);
    }

    summary.appendChild(navigation);
  }());

  productTitle.classList.add('kjs-option1-title');
  summary.appendChild(productTitle);

  (function moveItemCode() {
    var sku = panel.querySelector('.variant-sku');
    if (sku) summary.appendChild(sku);
  }());

  panel.insertBefore(summary, panel.firstChild);
  if (titleSource) titleSource.classList.add('kjs-option1-title-source');

  price = purchaseControls.querySelector('.price');
  galleryColumn = document.querySelector('.pro_main_c .row > .col-lg-6:first-child');
  mobileQuery = window.matchMedia('(max-width: 767px)');

  function syncSummaryPosition() {
    if (mobileQuery.matches && galleryColumn) {
      galleryColumn.insertBefore(summary, galleryColumn.firstChild);
      summary.classList.add('kjs-option1-summary--mobile');
      if (price) summary.appendChild(price);
      if (categoryNavigation && productDetails) {
        productDetails.insertBefore(categoryNavigation, productDetails.children[1] || null);
        categoryNavigation.classList.add('kjs-option1-categories--details');
      }
    } else {
      panel.insertBefore(summary, panel.firstChild);
      summary.classList.remove('kjs-option1-summary--mobile');
      if (price) purchaseControls.insertBefore(price, purchaseControls.firstChild);
      if (categoryNavigation) {
        summary.insertBefore(categoryNavigation, productTitle);
        categoryNavigation.classList.remove('kjs-option1-categories--details');
      }
    }
  }

  (function buildProductDetails() {
    var heading = panel.querySelector('.kjs-product-details-heading');
    var label = heading && heading.nextElementSibling;
    var descriptionFirst = panel.querySelector('.description-first-part');
    var descriptionMain = panel.querySelector('[class*="main-product-description-"]');
    var details;
    var detailsSummary;

    if (!heading || (!descriptionFirst && !descriptionMain)) return;

    details = document.createElement('details');
    details.className = 'kjs-option1-disclosure';
    details.open = true;
    productDetails = details;
    detailsSummary = document.createElement('summary');
    detailsSummary.textContent = 'Product details';
    details.appendChild(detailsSummary);
    heading.parentNode.insertBefore(details, heading);

    if (descriptionFirst) details.appendChild(descriptionFirst);
    if (descriptionMain) details.appendChild(descriptionMain);
    if (label && label.tagName && label.tagName.toLowerCase() === 'h5') label.parentNode.removeChild(label);
    heading.parentNode.removeChild(heading);
  }());

  (function simplifyPickupAvailability() {
    var availability = panel.querySelector('.product-single__store-availability-container');
    var observer;

    if (!availability) return;

    function simplify() {
      var information = availability.querySelector('.store-availability-information');
      var informationContainer = availability.querySelector('.store-availability-information-container');
      var button = availability.querySelector('.store-availability-information__button');
      var note;

      if (!information || !informationContainer || !button) return false;

      if (!availability.classList.contains('kjs-option1-pickup-summary')) {
        availability.classList.add('kjs-option1-pickup-summary');
      }
      note = informationContainer.querySelector('.kjs-option1-pickup-note');
      if (!note) {
        note = document.createElement('p');
        note.className = 'kjs-option1-pickup-note';
        note.textContent = 'In-stock items are usually ready for pickup within 24 hours.';
        informationContainer.insertBefore(note, button);
      }

      if (button.textContent.replace(/^\s+|\s+$/g, '') !== 'Store & pickup details') {
        button.textContent = 'Store & pickup details';
      }
      if (button.getAttribute('aria-label') !== 'View store and pickup details') {
        button.setAttribute('aria-label', 'View store and pickup details');
      }
      return true;
    }

    simplify();
    if (window.MutationObserver) {
      observer = new MutationObserver(simplify);
      observer.observe(availability, { childList: true, subtree: true });
    }
  }());

  (function addProductHelp() {
    var availability = panel.querySelector('.product-single__store-availability-container');
    var details = panel.querySelector('.kjs-option1-disclosure');
    var help = document.createElement('a');
    var insertionPoint = details || panel.querySelector('.product_tags') || panel.querySelector('.review_row');

    help.className = 'kjs-option1-help';
    help.href = 'tel:+12465388833';
    help.textContent = 'Need help choosing? Call (246) 538-8833';

    if (availability && availability.parentNode) {
      availability.parentNode.insertBefore(help, availability.nextSibling);
    } else if (insertionPoint && insertionPoint.parentNode) {
      insertionPoint.parentNode.insertBefore(help, insertionPoint);
    } else {
      panel.appendChild(help);
    }
  }());

  function renameRecommendations() {
    var headings = document.querySelectorAll('h3');
    var index;
    for (index = 0; index < headings.length; index += 1) {
      if (/^\s*Related products/i.test(headings[index].textContent)) {
        headings[index].textContent = 'You may also need';
        return true;
      }
    }
    return false;
  }

  if (!renameRecommendations() && window.MutationObserver) {
    (function watchRecommendations() {
      var observer = new MutationObserver(function () {
        if (renameRecommendations()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () { observer.disconnect(); }, 12000);
    }());
  }

  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', syncSummaryPosition);
  else mobileQuery.addListener(syncSummaryPosition);

  syncSummaryPosition();
  body.classList.add('kjs-option1-ready');
}());

